module.exports = __webpack_public_path__ + "static/media/HS1HJ.ca6f0a43.jpg";